import { constraints } from "../../utils/validation";
import { each, get, forIn, includes, isEmpty, mapValues, set, uniqBy } from "lodash";
import listingValidation from "../../listing/ducks/validation";
import listingValidationNonRequired from "../../listing/ducks/listingValidationNonRequired";
import validate from "validate.js";

const compConstraintsNonRequired = {
    Office: {
        "listing.attributes.specialtyType": {},
    },
    Industrial: {
        "listing.attributes.specialtyType": {},
        "listing.attributes.sfAvail": {
            ...constraints.number,
        },
        "listing.attributes.largestContigSf": {
            ...constraints.number,
        },
        "listing.attributes.officeSf": {
            ...constraints.wholeNumber,
        },
        "listing.attributes.yardSf": {
            ...constraints.wholeNumber,
        },
        "listing.attributes.suite": {},
        "listing.attributes.officeBreakdownSfRate": {
            ...constraints.number,
        },
        "listing.attributes.warehouseShellBreakdownRate": {
            ...constraints.number,
        },
        "listing.attributes.blendedRate": {
            ...constraints.number,
        },
        "listing.attributes.voltsNum": {},
        "listing.attributes.ampsNum": {
            ...constraints.number,
        },
        "listing.attributes.phaseNum": {
            ...constraints.number,
        },
        "listing.attributes.gradeLevelDoorsNum": {
            ...constraints.integer,
        },
        "listing.attributes.dockHighDoorsNum": {
            ...constraints.integer,
        },
        "listing.attributes.railDoorsNum": {
            ...constraints.integer,
        },
        "listing.attributes.clearHeightMin": {
            ...constraints.wholeNumber,
        },
        "listing.attributes.clearHeightMax": {
            ...constraints.wholeNumber,
        },
        "listing.attributes.cranesQty": {
            ...constraints.wholeNumber,
        },
        "listing.attributes.craneNotes": {},
        "listing.attributes.yardNotes": {},
        "listing.attributes.industrialSf": {
            ...constraints.wholeNumber,
        },
    },
    Retail: {
        "listing.attributes.specialtyType": {},
    },
    Land: {
        "listing.attributes.specialtyType": {},
    },
    Multifamily: {
        "listing.attributes.specialtyType": {},
    },
    Hospitality: {
        "listing.attributes.specialtyType": {},
        "listing.attributes.hospitalitySf": {
            ...constraints.id,
        },
        "listing.attributes.hospitalityUnitCount": {
            ...constraints.id,
        },
        "listing.attributes.roomCount": {
            ...constraints.id,
        },
    },
    Other: {
        "listing.attributes.specialtyType": {},
    },
    Educational: {
        "listing.attributes.classroomCount": {
            ...constraints.number,
        },
        "listing.attributes.auditoriumSeatsCount": {
            ...constraints.number,
        },
    },
    Religious: {},
    Healthcare: {
        "listing.attributes.specialtyType": {},
    },
    totalConsideration: {
        commencementDate: {
            ...constraints.date,
        },
        expirationDate: {
            ...constraints.date,
        },
        termNumMonths: {
            ...constraints.number,
        },
        squareFeet: {
            ...constraints.number,
        },
        ratePerMonth: {
            ...constraints.number,
        },
        ratePerSqftPerMonth: {
            ...constraints.number,
        },
        ratePerSqftPerYear: {
            ...constraints.number,
        },
        escalationRate: {
            ...constraints.number,
        },
        escalationTerm: {
            ...constraints.number,
        },
    },
    listingInformation: {
        "listing.listingName": {},
        "listing.dateListed": {
            ...constraints.date,
        },
        "listing.dateAvailable": {
            ...constraints.date,
        },
        "listing.expirationDate": {
            ...constraints.date,
        },
        "listing.leaseExpirationDate": {
            ...constraints.date,
        },
        "listing.attributes.totalUnits": {
            ...constraints.number,
        },
        "listing.attributes.numBldg": {
            ...constraints.number,
        },
        "listing.attributes.lotAcres": {
            ...constraints.number,
        },
        "listing.attributes.lotSf": {
            ...constraints.number,
        },
        "listing.attributes.amenities": {},
        "listing.attributes.tourInstructions": {},
        "listing.sfAvail": {
            ...constraints.number,
        },
        "listing.sfDivisibleTo": {
            ...constraints.number,
        },
        "listing.sellerLandlordCommonCompanyName": {
            ...constraints.maxLength,
        },
        "listing.sellerLandlordLegalCompanyName": {
            ...constraints.maxLength,
        },
    },
    leaseDetails: {
        tiRate: {
            ...constraints.number,
            ...constraints.between0And1000,
        },
        leaseType: {},
        movingAllowanceAmount: {
            ...constraints.number,
        },
        buyerTenantBusinessType: {},
        naicsCode: {
            ...constraints.id,
        },
        sicCode: {
            ...constraints.id,
        },
        previousLocation: {},
        currentSf: {
            ...constraints.number,
        },
        squareFeetChange: {
            ...constraints.number,
        },
    },
    Lease: {
        //Comp information
        transactionDate: {
            ...constraints.date,
        },
        totalKmCommission: {
            ...constraints.number,
        },
        paymentMethod: {},
        leaseBackFlg: {},
        spaceType: {},
        representationType: {},
        //other constraints
        "buyerTenantCompany.displayName": {},
        "buyerTenantCompany.legalName": {},
        "buyerTenantCompany.parentCompany.displayName": {},
        outsideBrokerCommission: {
            ...constraints.number,
        },
    },
    Sale: {
        //required fields
        transactionDate: {
            ...constraints.date,
        },
        totalKmCommission: {
            ...constraints.number,
        },
        paymentMethod: {},
        leaseBackFlg: {},
        spaceType: {},
        representationType: {},
        totalConsiderationAmount: {
            ...constraints.number,
        },
        squareFeet: {
            ...constraints.number,
        },
    },
    buildingInformation: {},
    parkingInformation: {
        "listing.attributes.parkingTotal": {
            ...constraints.number,
        },
        "listing.attributes.parkingRatio": {},
        "listing.attributes.surfaceParkingSpaceCount": {
            ...constraints.number,
        },
        "listing.attributes.parkingGarageSpaceCount": {
            ...constraints.number,
        },
        "listing.attributes.parkingReservedSpaceCount": {
            ...constraints.number,
        },
        "listing.attributes.carportParkingSpaceCount": {
            ...constraints.number,
        },
        "listing.attributes.parkingNotes": {},
    },
    listingFinancial: {
        "listing.leaseType": {},
        "listing.improvementAllowance": {
            ...constraints.number,
        },
        "listing.askingRentMax": {
            ...constraints.number,
        },
        "listing.askingRentPerMonth": {
            ...constraints.number,
        },
        "listing.baseRentPerYear": {
            ...constraints.number,
        },
        "listing.expenseType": {},
        "listing.expenseTypeValue": {},
        "listing.nnnPerMonth": {
            ...constraints.number,
        },
        "listing.nnnPerYear": {
            ...constraints.number,
        },
        "listing.totalMonthlyRent": {
            ...constraints.number,
        },
        "listing.totalRentPerYear": {
            ...constraints.number,
        },
        "listing.procuringBrokerCommission": {},
    },
    saleFinancial: {
        "listing.listPrice": {},
    },
};

const installmentConstraints = {
    amount: {
        ...constraints.number,
    },
    dueDate: {
        ...constraints.date,
    },
};

const validateNonRequired = (comp, useType, transactionType, documents) => {
    let whatToValidate = [];
    switch (transactionType) {
        case "Lease":
            whatToValidate = [
                useType,
                transactionType,
                "leaseDetails",
                "totalConsideration",
                "listingInformation",
                "buildingInformation",
                "parkingInformation",
                "listingFinancial",
            ];
            break;
        case "Sale":
            whatToValidate = [
                useType,
                transactionType,
                "listingInformation",
                "buildingInformation",
                "parkingInformation",
                "saleFinancial",
            ];
            break;
        default:
            break;
    }
    let combinedConstraints = {};
    each(whatToValidate, (section) => {
        combinedConstraints = { ...combinedConstraints, ...compConstraintsNonRequired[section] };
    });
    let errors = {
        ...mapValues(validate(comp, combinedConstraints, { fullMessages: false }), (error) => {
            return error[0];
        }),
        ...listingValidation.validateListingBrokersCompany(get(comp, "listing.listingBrokers")),
        ...listingValidationNonRequired.validateMixedUses(get(comp, "listing.attributes.mixedUses")),
        ...listingValidationNonRequired.validatePortfolioProperties(
            get(comp, "listing.attributes.portfolioProperties")
        ),
        ...listingValidationNonRequired.validateCondos(get(comp, "listing.attributes.condos")),
        ...validateInstallments(get(comp, "installments")),
    };
    let setErrors = {};
    forIn(errors, (value, key) => {
        set(setErrors, key, value);
    });
    return setErrors;
};

const validateInstallments = (installments) => {
    let errors = {};
    if (installments) {
        for (let i = 0; i < installments.length; i++) {
            const validationResponse = validateInstallment(installments[i]);
            if (validationResponse) {
                set(errors, `${i}`, {
                    ...mapValues(validationResponse, (value, key) => {
                        return value[0];
                    }),
                });
            }
        }
    }
    return isEmpty(errors) ? {} : { installments: errors };
};

const validateInstallment = (installment) => {
    return validate(installment, installmentConstraints, { fullMessages: false });
};

const getPanelsToExpand = (errors, useType, transactionType) => {
    let listingInformationConstraints = {};
    each([useType, "listingInformation", "parkingInformation"], (section) => {
        listingInformationConstraints = { ...listingInformationConstraints, ...compConstraintsNonRequired[section] };
    });

    let generalInformationConstraints = {};
    each([transactionType], (section) => {
        generalInformationConstraints = { ...generalInformationConstraints, ...compConstraintsNonRequired[section] };
    });

    const otherListingInfo = [
        "attributes.condos",
        "attributes.mixedUses",
        "attributes.portfolioProperties",
        "listing.listingBrokers",
    ];
    const otherCompInfo = ["installments"];

    let panelsToExpand = [];
    forIn(errors, (value, key) => {
        if (
            includes(
                [
                    ...Object.keys(compConstraintsNonRequired.listingFinancial),
                    ...Object.keys(compConstraintsNonRequired.saleFinancial),
                ],
                key
            )
        ) {
            panelsToExpand.push("listingFinancial");
        } else if (includes([...Object.keys(listingInformationConstraints), ...otherListingInfo], key)) {
            panelsToExpand.push("listingInformation");
        } else if (includes([...Object.keys(generalInformationConstraints), ...otherCompInfo], key)) {
            //ignore, comp information opened and closed manually
            panelsToExpand.push("compInformation");
        }
    });

    panelsToExpand = uniqBy(panelsToExpand, function (e) {
        return e;
    });

    return panelsToExpand;
};

export default {
    getPanelsToExpand,
    validateNonRequired,
    validateInstallments,
};
